import { render } from "./section-one.vue?vue&type=template&id=52cae6ce&scoped=true"
const script = {}

import "./section-one.vue?vue&type=style&index=0&id=52cae6ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cae6ce"]])

export default __exports__